import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fetchModels: {
    CostModel: {},
    PriceModel: {},
    error: false,
  },
  createProvider: {
    createdProvider: {},
    loading: false,
    error: false,
  },
};

export const merchantSlice = createSlice({
  name: 'provider',
  initialState,
  reducers: {
    fetchCostModelReducer: (state, { payload }) => {
      state.fetchModels.CostModel = payload.data;
    },
    fetchPriceModelReducer: (state, { payload }) => {
      state.fetchModels.PriceModel = payload.data;
    },
    errorfetchingCostModelReducer: (state) => {
      state.fetchModels.errorCost = true;
    },

    creatingProviderReducer: (state) => {
      state.createProvider.loading = true;
      state.createProvider.createdProvider = {};
      state.createProvider.error = false;
    },
    providerCreatedReducer: (state, { payload }) => {
      state.createProvider.loading = false;
      state.createProvider.createdProvider = payload.data;
      state.createProvider.error = false;
    },
    errorCreatingProviderReducer: (state, { payload }) => {
      state.createProvider.loading = false;
      state.createProvider.createdProvider = {};
      state.createProvider.error = true;
    },
  },
});
export const {
  fetchCostModelReducer,
  errorfetchingCostModelReducer,
  fetchPriceModelReducer,
  creatingProviderReducer,
  providerCreatedReducer,
  errorCreatingProviderReducer,
} = merchantSlice.actions;

export default merchantSlice.reducer;
